import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton, Stack } from '@fluentui/react';
import { useBoolean } from '@uifabric/react-hooks';
import styles from './index.module.scss';
import HubShare from '../../components/HubShare';
import { HubFile } from '../../model';
import hubService from '../../api/services/hub';
import { Flex } from '@fluentui/react-northstar';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';

interface Attendee {
    email: string;
    name: string;
    status: string;
}


const HubShareDialog = ({
    isOpen,
    onDismiss,
    attendee,
    files,
    onSuccess,
    subject = '',
    isMobile,
    inMeeting = '',
    isPersonal
}: {
    subject?: string;
    isOpen: boolean,
    onDismiss: () => void,
    onSuccess: () => void;
    files: HubFile[],
    attendee: Attendee[],
    isMobile?: boolean,
    inMeeting?: string,
    isPersonal?:boolean

}) => {
    const {theme} = useTypedSelector((state: ApplicationState) => state.meeting);
    const [formValid, setFormValid] = React.useState(false);
    const [saving, setSaving] = React.useState(false)
    const [] = React.useState('');
    const [hideShareDialog, { toggle: toggleShareDialog, setTrue: openDialog, setFalse: hideDialog }] = useBoolean(true);
    const dialogAddFilesContentProps = {
        type: DialogType.normal,
        title: 'Share',
        subText: '',
        titleProps: {
            style: { color: theme === "default" ? '#000000' : '#FFFFFF' }
        },
    };
    const [currentFiles, setCurrentFiles] = React.useState([] as HubFile[]);
    const [txtSubject, setTxtSubject] = React.useState(subject);
    const [txtMessage, setTxtMessage] = React.useState('');
    const [txtSubjectError, setTxtSubjectError] = React.useState('');
    const [txtMessageError, setTxtMessageError] = React.useState('');
    const [attendies, setAttendies] = React.useState([] as {
        email: string,
        name: string,
        status: string
    }[]);
    const modalPropsStyles = { main: { width: '80% !important', maxWidth: 1200 } };
    const modalProps = React.useMemo(() => ({
        isBlocking: true,
        styles: modalPropsStyles,
    }), []);
    const onMessageChange = (data: string) => {
        setTxtMessage(data);
        if (!data) {
            setTxtMessageError('Message can not be empty.');
            setFormValid(false);
        } else {
            setTxtMessageError('');
            setFormValid(true);
        }
    };
    const onSubjectChange = (data: string) => {
        setTxtSubject(data);
        if (!data) {
            setTxtSubjectError('Subject can not be empty.')
        } else {
            setTxtSubjectError('');
        }

        if (data && txtMessage) {
            setFormValid(true);
        } else {
            setFormValid(false);
        }
    };
    const onRemoveClick = (fileId: number) => {
        const newFiles = currentFiles.filter(c => c.id !== fileId);
        setCurrentFiles(newFiles);
    };
    const onSave = () => {
        setSaving(true);
        hubService.serverShare({
            langCode: '',
            emails: attendies.map(c => c.email),
            files: currentFiles.map(c => c.id),
            subject: subject,
            note: txtMessage
        }).then(() => {
            //movo to redux
            onDismiss();
            toggleShareDialog();
            setSaving(false);
            onSuccess && onSuccess();
        });
    };

    React.useEffect(() => {
        isOpen ? openDialog() : hideDialog();
        setAttendies(attendee);
        setCurrentFiles(files);
    }, [isOpen, files, attendee])

    const renderDesktop = () => {
        return (
            <>
                <Dialog
                    containerClassName={[styles.root, styles["ms-teams-theme-" + theme]].join(' ')}
                    hidden={hideShareDialog}
                    onDismiss={onDismiss}
                    maxWidth={600}
                    dialogContentProps={dialogAddFilesContentProps}
                    modalProps={modalProps}>
                    <div className={styles.contentList}>
                        <HubShare
                            messageError={txtMessageError}
                            subjectError={txtSubjectError}
                            onMessageChange={onMessageChange}
                            subject={txtSubject}
                            message={txtMessage}
                            onSubjectChange={onSubjectChange}
                            emails={attendies} files={currentFiles} onRemoveClick={onRemoveClick} />
                    </div>
                    <DialogFooter>
                        <DefaultButton onClick={() => { toggleShareDialog(); onDismiss(); }} text="Cancel" />
                        <PrimaryButton disabled={!formValid} onClick={onSave} text={saving ? 'Saving...' : `Share`} />
                    </DialogFooter>
                </Dialog>
            </>
        )
    };

    const renderMobile = () => {
        return (
            <>
                <Flex className={[styles.rootMobile, inMeeting.length > 0 ? styles["inMeetingColor"] : styles["ms-teams-theme-" + theme]].join(' ')}>
                    <Flex className={styles.shareFlex}>
                        <HubShare
                            messageError={txtMessageError}
                            subjectError={txtSubjectError}
                            onMessageChange={onMessageChange}
                            subject={txtSubject}
                            message={txtMessage}
                            onSubjectChange={onSubjectChange}
                            emails={attendies} files={currentFiles} onRemoveClick={onRemoveClick}
                            isMobile={true}
                            isPersonal={isPersonal}/>
                    </Flex>
                    <Flex className={styles.buttonContainer}>
                        <DefaultButton className={styles.btns} onClick={() => { toggleShareDialog(); onDismiss(); }} text="Cancel" />
                        <PrimaryButton className={styles.btns} disabled={!formValid} onClick={onSave} text={saving ? 'Saving...' : `Share`} />
                    </Flex>
                </Flex>
            </>
        )
    };

    return (
        <>
            {!isMobile && renderDesktop()}
            {isMobile && renderMobile()}
        </>
    );
};


export default HubShareDialog